import React from "react";
import { TextInput, Platform } from "react-native";

import { cn } from "@/lib/utils";

const Input = React.forwardRef<
	React.ElementRef<typeof TextInput>,
	React.ComponentPropsWithoutRef<typeof TextInput>
>(({ className, placeholderClassName, ...props }, ref) => {
	return (
		<TextInput
			ref={ref}
			className={cn(
				"flex h-12 w-full items-center justify-center rounded-md border border-input bg-background px-4 text-base text-foreground",
				Platform.OS === 'android' && "py-2",
				className,
			)}
			placeholderClassName={cn("text-muted-foreground", placeholderClassName)}
			textAlignVertical="center"
			style={Platform.OS === 'android' ? { paddingVertical: 12, includeFontPadding: false } : undefined}
			{...props}
		/>
	);
});

Input.displayName = "Input";

export { Input };
